/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable prettier/prettier */
import { GET_ERRORS, CLEAR_ERRORS } from './errorType'

const initialState = {
  message: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return {
        message: action.payload.message,
      }
    case CLEAR_ERRORS:
      return {
        message: null,
      }
    default:
      return state
  }
}
